const PesquisarMovimentacaoEstoqueController = ControllerBase.extend({
    name: "PesquisarMovimentacaoEstoqueController",
    framework: "knockout",
    dataBreadcrumb: new DataBreadcrumb({
        columns: [
            { title: 'Produto', prop: 'CodigoProduto' },
            { title: 'Descrição', prop: 'DescricaoProduto' }
        ],
        getData: function () {
            var modelAux = this.produto.toJSON();

            if (modelAux.IdentificadorOrcamento) {
                modelAux.CodigoProduto = modelAux.CodigoProdutoExibicao;
            }

            return modelAux;
        },
    }),

    ajax: function () {
        return {
            url: "/Produto/_MovimentacaoEstoque",
            type: "post",
            cache: false,
        };
    },


    //selecionar a data pelo datepicker não dispara esse evento, ele é disparado apenas se a data for digitada.
    habilitaPesquisar: function () {
        const self = this;
        var DataInicio = self.filtros.filtroDataInicio() == "" ? $("#inpfiltroDataInicio").val() : self.filtros.filtroDataInicio();
        var DataFim = self.filtros.filtroDataFim() == "" ? $("#inpfiltroDataFim").val() : self.filtros.filtroDataFim();

        self.filtros.filtroDataInicio(DataInicio);
        self.filtros.filtroDataFim(DataFim);


        if (!DataInicio || !DataFim) {
            self.filtros.pesquisarDesabilitado(true);

            if (!DataInicio) {
                document.getElementById("inpfiltroDataInicio").style.borderColor =
                    "red";
            } else {
                document.getElementById("inpfiltroDataInicio").style.borderColor = "";
            }

            if (!DataFim) {
                document.getElementById("inpfiltroDataFim").style.borderColor = "red";
            } else {
                document.getElementById("inpfiltroDataFim").style.borderColor = "";
            }
        } else {
            var regex = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/;
            var dataInicioValida = regex.test(DataInicio);
            var dataFimValida = regex.test(DataFim);

            if (dataInicioValida && dataFimValida) {
                self.filtros.pesquisarDesabilitado(false);
                document.getElementById("inpfiltroDataInicio").style.borderColor = "";
                document.getElementById("inpfiltroDataFim").style.borderColor = "";
            } else {
                if (!dataInicioValida) {
                    global.showWarnMessage("Data Início inválida.");
                    document.getElementById("inpfiltroDataInicio").style.borderColor =
                        "red";
                } else {
                    document.getElementById("inpfiltroDataInicio").style.borderColor = "";
                }
                if (!dataFimValida) {
                    global.showWarnMessage("Data Final inválida");
                    document.getElementById("inpfiltroDataFim").style.borderColor = "red";
                } else {
                    document.getElementById("inpfiltroDataFim").style.borderColor = "";
                }
                self.filtros.pesquisarDesabilitado(true);
            }
        }
        return true;
    },

    antesBinding: function () {
        const me = this;

        //Limpar os campos
        me.filtros.filtroDataInicio(undefined);
        me.filtros.filtroDataFim(undefined);
        me.filtros.filialSelecionada(undefined);
        me.filtros.pesquisarTpo(false);
        me.filtros.listaTpo([]);

        global.ajax({
            url: "/Produto/ListarFiliais",
            type: "get",
            cache: false,
            success: function (data) {
                if (data) {
                    me.filtros.filiais(data);
                } else {
                    console.log("Sem Registros");
                }
            },
        });

        this.select2tpos = {
            ajax: {
                url: "/Produto/ListarTposPorAtributo",
                type: "post",
                data: function (params) {
                    return {
                        atributo: params.term,
                    };
                },
                processResults: function (data) {
                    return {
                        results: $.map(data, function (i) {
                            return {
                                id: i.HierarquiaNumero,
                                text: i.HierarquiaMascara + " - " + i.Nome,
                            };
                        }),
                    };
                },
            },
            minimumInputLength: 3,
            theme: "classic",
        };
    },

    filtros: {
        pesquisarTpo: ko.observable(),
        listaTpo: ko.observableArray([]),
        filialSelecionada: ko.observable(""),
        filiais: ko.observable([]),
        atributoTpo: ko.observable(),
        pesquisarDesabilitado: ko.observable(false),
        filtroDataInicio: ko.observable().extend({ required: true }),
        filtroDataFim: ko.observable().extend({ required: true }),
    },

    checkFiltrarTpo: function (params) {
        const me = this;
        var divTpo = document.getElementById("divTpo");

        if (me.filtros.pesquisarTpo() == true) {
            divTpo.style.display = "";
        } else {
            divTpo.style.display = "none";
        }

        return true;
    },

    pesquisar: function () {
        const me = this;


        ////Data Inicio
        //var diaInicio = me.filtros.filtroDataInicio().split("/")[0];
        //var mesInicio = me.filtros.filtroDataInicio().split("/")[1];
        //var anoInicio = me.filtros.filtroDataInicio().split("/")[2];

        ////DataFim

        //var diaFim = me.filtros.filtroDataFim().split("/")[0];
        //var mesFim = me.filtros.filtroDataFim().split("/")[1];
        //var anoFim = me.filtros.filtroDataFim().split("/")[2];

        global.ajax({
            url: "/Produto/MovimentacaoEstoque",
            type: "post",
            cache: false,
            data: {
                codigoProduto: me.produto.get("Codigo"),
                filtroDataInicio: me.filtros.filtroDataInicio() , // anoInicio + "/" + mesInicio + "/" + diaInicio + " 00:00:00",
                filtroDataFim: me.filtros.filtroDataFim() , // anoFim + "/" + mesFim + "/" + diaFim + " 00:00:00",
                pesquisarTpo: me.filtros.pesquisarTpo(),
                listaTpo: me.filtros.listaTpo(),
                filial: me.filtros.filialSelecionada(),
            },
            success: function (retorno) {

                if (retorno == null || (retorno != null && retorno.length == 0) || (retorno != null && retorno == [])) {
                    me.model([]);
                    global.showWarnMessage(
                        "Nenhum registro encontrado para os filtros informados."
                    );
                } else {
                    var m = ko.mapping.fromJS(retorno);
                    if (m.HasErrors == undefined) {
                        me.model(m());
                    }
                    else {
                        me.model([]);
                    }

                }
            },
            error: function (error) {
                me.model([]);
            },
        });
    },

})

window.PesquisarMovimentacaoEstoqueController = PesquisarMovimentacaoEstoqueController

export {
    PesquisarMovimentacaoEstoqueController
}
